"use client";

import { Suspense } from "react";
import DataTabs from "@/components/DataTabs";

export default function StructurePage() {
  return (
    <main>
      <Suspense fallback={<div>Loading...</div>}>
        <DataTabs initialTab="structure" showTabBar={false} />
      </Suspense>
    </main>
  );
}
